import React, { useEffect } from 'react';
import { Alert, Button, Box } from '@mui/material';

/**
 * EditSuccessAlert Component
 * 
 * Displays a success message after a change is successfully edited.
 * Provides two action buttons:
 * - "Add Comment": Allows user to add a comment explaining the edit
 * - "Return Home": Returns user to the project home view
 * 
 * Auto-dismisses after 10 seconds and can be manually dismissed via the close button.
 * 
 * @param {Object} props
 * @param {Function} props.onAddComment - Callback function when "Add Comment" button is clicked
 * @param {Function} props.onReturnHome - Callback function when "Return Home" button is clicked
 * @param {Function} props.onDismiss - Callback function when alert is dismissed (close button or auto-dismiss)
 */
const EditSuccessAlert = ({ onAddComment, onReturnHome, onDismiss }) => {
  // Auto-dismiss after 10 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      onDismiss();
    }, 10000);

    // Cleanup timer on unmount
    return () => clearTimeout(timer);
  }, [onDismiss]);

  return (
    <Alert
      severity="success"
      onClose={onDismiss}
      sx={{ mb: 2 }}
      action={
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button color="inherit" size="small" onClick={onAddComment}>
            Add Comment
          </Button>
          <Button color="inherit" size="small" onClick={onReturnHome}>
            Return Home
          </Button>
        </Box>
      }
    >
      Change updated successfully! Would you like to add a comment to explain your edit?
    </Alert>
  );
};

export default EditSuccessAlert;
